import { render } from "./PortfolioFilter.vue?vue&type=template&id=15285945"
import script from "./PortfolioFilter.vue?vue&type=script&lang=js"
export * from "./PortfolioFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__